import { BackgroundInfoType } from './enums/background-info-type';

export class BackgroundInfoSubTopic {
  jurisdictionId?: number;
  topicName = '';
  topicId: number;
  subtopicHeader = '';
  subtopicDiscussionPoints = '';
  backgroundInfoId?: number;
  topicObjectType: BackgroundInfoType;
  topicSortOrder: number;
  topicTaxYear: number;
  subtopicSortOrder: number;
  discussion?: string;
  notes?: string;
  currentSubtopicIndex?: number;
  completed: boolean;
}
